import React from 'react';
import { ShieldCheck, Lock, CheckCircle2 } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function Garantia() {
  const revealRef = useScrollReveal();
  return <section id="garantia" className="py-14 sm:py-[90px] px-6" style={{
    background: 'linear-gradient(160deg, #0a0f0a, #0a0a0a)'
  }} data-id="element-197">
      <div ref={revealRef} className="max-w-[1060px] mx-auto reveal" data-id="element-198">
        <div className="text-center" data-id="element-199">
          <span className="text-[11px] tracking-[5px] uppercase text-oro mb-4 block" data-id="element-200">
            Sin riesgo para ti
          </span>
          <h2 className="font-playfair text-[clamp(28px,4.5vw,52px)] font-bold leading-[1.15] mb-6" data-id="element-201">
            Garantía total de 7 días
          </h2>
          <div className="w-[60px] h-[2px] bg-gradient-to-r from-oro to-transparent mx-auto my-5" data-id="element-202"></div>
        </div>

        <div className="flex flex-col sm:flex-row items-center gap-16 max-w-[860px] mx-auto mt-12 text-center sm:text-left" data-id="element-203">
          <div className="relative shrink-0" data-id="element-204">
            <div className="absolute inset-0 bg-oro/20 rounded-full blur-2xl scale-125" data-id="element-205"></div>
            <img src="https://i.postimg.cc/brqt5whM/selo-garantia-png-2.webp" alt="Garantía 7 días" className="relative w-[180px] animate-float-badge brightness-150 drop-shadow-[0_0_20px_rgba(201,168,76,0.4)]" data-id="element-206" />
          </div>

          <div data-id="element-207">
            <h2 className="font-playfair text-[clamp(24px,3vw,38px)] font-bold mb-4" data-id="element-208">
              Si no te convence,
              <br data-id="element-209" />
              te devolvemos cada centavo.
            </h2>
            <p className="text-[15px] text-white/70 leading-[1.8] mb-4" data-id="element-210">
              Tienes 7 días completos para aplicar El Método Italiano™, cocinar
              las recetas y evaluar si cumple lo que promete. Si por cualquier
              motivo no estás satisfecho, escribes un mensaje y procesamos el
              reembolso completo, sin preguntas, sin demoras.
            </p>
            <p className="text-[15px] text-white/70 leading-[1.8]" data-id="element-211">
              Ofrezco esta garantía porque confío en lo que construí. El riesgo
              es mío, no tuyo.
            </p>

            <div className="flex flex-wrap gap-6 mt-6 justify-center sm:justify-start" data-id="element-212">
              <span className="text-[13px] text-white/60 flex items-center gap-1.5" data-id="element-213">
                <ShieldCheck size={14} className="text-verde" data-id="element-214" /> Reembolso total
                garantizado
              </span>
              <span className="text-[13px] text-white/60 flex items-center gap-1.5" data-id="element-215">
                <Lock size={14} className="text-verde" data-id="element-216" /> Sin preguntas
              </span>
              <span className="text-[13px] text-white/60 flex items-center gap-1.5" data-id="element-217">
                <CheckCircle2 size={14} className="text-verde" data-id="element-218" /> 7 días desde
                tu compra
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}